$(document).ready(function () {
    colorboxModal();
});

function colorboxModal() {
    $(".cbox").colorbox({
        iframe: true,
        scrolling: true,
        width: "80%",
        height: "80%"
    });
}
